import { render, staticRenderFns } from "./Klassen.vue?vue&type=template&id=601dcf3c&scoped=true&"
import script from "./Klassen.vue?vue&type=script&lang=js&"
export * from "./Klassen.vue?vue&type=script&lang=js&"
import style0 from "./Klassen.vue?vue&type=style&index=0&id=601dcf3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601dcf3c",
  null
  
)

export default component.exports